import { React, useState, useEffect, createContext, useMemo, useRef } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const CaracteristicasModal = ({ open, onClose, modelo, caracteristicas }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const formatearCaracteristicas = (texto) => {
    if (!texto) return "";
    return texto.split(",").map((c, i) => <div key={i}>{c.trim()}</div>);
};

    // console.log (JSON.stringify(infoModelo.imagenes.filter(img => img !== null)))
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="modelos-modal-formulario">
                    <div className="modelos-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={`CARACTERISTICAS DE ${modelo}`}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`modelos-modal-caracteristicas`}>
                                    <div className="modelos-modal-caracteristicas-container">
                                        {caracteristicas}
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};